import { useAtomValue } from 'jotai';
import { useSidePanel } from '../side-panel-provider';
export const useAnnotations = () => {
  const {
    annotationsAtom
  } = useSidePanel();
  const annotations = useAtomValue(annotationsAtom);
  return annotations;
};